import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ShoppingBag } from "lucide-react";
import { PageHeading, PageShell } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";
import { EmptyState, ErrorState, ProductSkeletonList } from "@/components/states";
import { OrderCard } from "@/components/orders/OrderCard";
import { useI18n } from "@/lib/i18n";
import { ordersQuery } from "@/lib/queries";
import { useAuth } from "@/lib/auth";
import { useRequireAuth } from "@/hooks/useRequireAuth";


export const Route = createFileRoute("/orders/")({
  component: OrdersPage,
});

function OrdersPage() {
  const { t } = useI18n();
  const { ready } = useRequireAuth();
  const { user } = useAuth();
  const history = useQuery({ ...ordersQuery(user?.id ?? ""), enabled: ready });
  const orders = history.data ?? [];

  return (
    <PageShell size="narrow">
      <PageHeading
        breadcrumbs={[{ label: t("nav.home"), to: "/" }, { label: t("orders.title") }]}
        title={t("orders.title")}
        description={t("orders.subtitle")}
        action={ready ? <Button variant="outline" disabled={history.isFetching} onClick={() => history.refetch()}>{t("orders.refresh")}</Button> : undefined}
      />
      {!ready || history.isPending ? (
        <ProductSkeletonList count={3} />
      ) : history.isError ? (
        <ErrorState
          error={history.error}
          message={t("orders.loadError")}
          onRetry={() => history.refetch()}
        />
      ) : orders.length === 0 ? (
        <EmptyState
          title={t("orders.empty")}
          description={t("orders.emptyDesc")}
          icon={<ShoppingBag className="size-7" />}
          action={
            <Button asChild>
              <Link to="/menu">{t("cart.browse")}</Link>
            </Button>
          }
        />
      ) : (
        <div className="grid gap-4">
          {orders.map((o) => (
            <OrderCard key={o.id} order={o} />
          ))}
        </div>
      )}
    </PageShell>
  );
}
